import { SubstituteProductionLotCatalogMutation } from "~/gql/mutations/produce/catalogSubstitution.generated";
import {
	PostProductionJobsMutation,
	ReopenProductionJobMutation,
	RepairProductionJobReservationPegsMutation
} from "~/gql/mutations/produce/postJobs.generated";
import {
	ClearProductionJobsProgressMutation,
	MarkProductionJobsDoneMutation,
	MarkProductionJobsStartedMutation,
	SetProductionJobNotesMutation
} from "~/gql/mutations/produce/productionCenterThisWeek.generated";
import {
	AddProductionMaterialEventToJobMutation,
	AddProductionSpaceEventToJobMutation,
	RemoveProductionMaterialEventFromJobMutation,
	RemoveProductionSpaceEventFromJobMutation
} from "~/gql/mutations/produce/productionJobEvents.generated";
import {
	ActivateProductionLotMutation,
	ApproveProductionLotMutation,
	BatchCreateDraftProductionLotsMutation,
	BatchOverrideProductionJobWeeksMutation,
	ClearJobPlannedHoursOverrideMutation,
	ClearProductionLotCustomerGroupMutation,
	ClearProductionLotCustomerMutation,
	ConfirmProducedQuantityEntryMutation,
	CreateProductionLotMutation,
	DeactivateProductionLotMutation,
	DeleteProductionLotMutation,
	MergeProductionPlanMutation,
	OverrideProducedQuantityMutation,
	OverrideProductionJobLocationMutation,
	OverrideProductionJobQuantityMutation,
	OverrideProductionJobWeekReadyMutation,
	OverrideProductionJobWeekStartMutation,
	OverrideProductionJobYieldMutation,
	OverrideProductionLotCustomerGroupMutation,
	OverrideProductionLotCustomerMutation,
	OverrideProductionLotQuantityMutation,
	PlanProductionJobMovesMutation,
	RecordShrinkEventMutation,
	RejectProducedQuantityEntryMutation,
	RemoveShrinkEventMutation,
	SetJobPlannedHoursOverrideMutation,
	SetProductionLotProductionItemMutation,
	SplitProductionLotMutation,
	SubmitDraftProductionLotMutation,
	SubmitProducedQuantityForReviewMutation,
	UpdateProductionJobLocationMutation
} from "~/gql/mutations/produce/productionSchedule.generated";
import { GetPostJobsDetailQuery } from "~/gql/queries/produce/postJobs.generated";
import {
	GetPendingProductionEntriesQuery,
	GetPlannedLotStartsPreviewQuery,
	GetProductionJobDimensionsQuery,
	GetProductionJobGrowWeeksQuery,
	GetProductionJobLabelsQuery,
	GetProductionJobPurchaseOrdersQuery,
	GetProductionJobsQuery,
	GetProductionLotEachesQuery,
	GetProductionLotOverrideHistoryQuery,
	GetProductionLotQuery,
	GetProductionLotsQuery,
	GetProductionPlansQuery,
	GetProductionScheduleJobQuery,
	GetProductionScheduleLotJobsQuery,
	GetRecipeJobIdsQuery,
	GetSplitProductionLotQuery,
	OpenPlannedMovesQuery,
	ProductionJobMovePreviewQuery
} from "~/gql/queries/produce/productionSchedule.generated";

export const productionScheduleEndpoints = {
	GetPendingProductionEntries: {
		providesTags: ["PendingProductionEntries"] as AddTagTypes,
		transformResponse: (res: GetPendingProductionEntriesQuery) => res
	},
	SubmitProducedQuantityForReview: {
		invalidatesTags: ["PendingProductionEntries"] as AddTagTypes,
		transformResponse: (res: SubmitProducedQuantityForReviewMutation) => res
	},
	ConfirmProducedQuantityEntry: {
		invalidatesTags: ["PendingProductionEntries", "ProductionLots", "ProductionJobs"] as AddTagTypes,
		transformResponse: (res: ConfirmProducedQuantityEntryMutation) => res
	},
	RejectProducedQuantityEntry: {
		invalidatesTags: ["PendingProductionEntries"] as AddTagTypes,
		transformResponse: (res: RejectProducedQuantityEntryMutation) => res
	},

	ClearProductionJobsProgress: {
		invalidatesTags: ["ProductionJobs"] as AddTagTypes,
		transformResponse: (res: ClearProductionJobsProgressMutation) => res
	},
	MarkProductionJobsDone: {
		invalidatesTags: ["ProductionJobs"] as AddTagTypes,
		transformResponse: (res: MarkProductionJobsDoneMutation) => res
	},
	MarkProductionJobsStarted: {
		invalidatesTags: ["ProductionJobs"] as AddTagTypes,
		transformResponse: (res: MarkProductionJobsStartedMutation) => res
	},
	SetProductionJobNotes: {
		invalidatesTags: ["ProductionJobs"] as AddTagTypes,
		transformResponse: (res: SetProductionJobNotesMutation) => res
	},
	ActivateProductionLot: {
		invalidatesTags: ["ProductionLots", "ProductionJobs", "SpaceUtilization"] as AddTagTypes,
		transformResponse: (res: ActivateProductionLotMutation) => res
	},
	AddProductionMaterialEventToJob: {
		invalidatesTags: ["ProductionLots", "ProductionJobs", "ProductionMaterialEvents"] as AddTagTypes,
		transformResponse: (res: AddProductionMaterialEventToJobMutation) => res
	},
	AddProductionSpaceEventToJob: {
		invalidatesTags: ["ProductionLots", "ProductionJobs", "ProductionSpaceEvents", "SpaceUtilization"] as AddTagTypes,
		transformResponse: (res: AddProductionSpaceEventToJobMutation) => res
	},
	ApproveProductionLot: {
		invalidatesTags: ["ProductionLots", "ProductionJobs", "SpaceUtilization"] as AddTagTypes,
		transformResponse: (res: ApproveProductionLotMutation) => res
	},
	BatchCreateDraftProductionLots: {
		invalidatesTags: ["ProductionLots", "ProductionJobs", "SpaceUtilization"] as AddTagTypes,
		transformResponse: (res: BatchCreateDraftProductionLotsMutation) => res
	},
	BatchOverrideProductionJobWeeks: {
		invalidatesTags: ["ProductionLots", "ProductionJobs", "SpaceUtilization", "TaskAssignments"] as AddTagTypes,
		transformResponse: (res: BatchOverrideProductionJobWeeksMutation) => res
	},
	ClearJobPlannedHoursOverride: {
		invalidatesTags: ["ProductionLots", "ProductionJobs", "SpaceUtilization", "TaskAssignments"] as AddTagTypes,
		transformResponse: (res: ClearJobPlannedHoursOverrideMutation) => res
	},
	ClearProductionLotCustomer: {
		invalidatesTags: ["ProductionLots", "ProductionJobs", "SpaceUtilization"] as AddTagTypes,
		transformResponse: (res: ClearProductionLotCustomerMutation) => res
	},
	ClearProductionLotCustomerGroup: {
		invalidatesTags: ["ProductionLots", "ProductionJobs", "SpaceUtilization"] as AddTagTypes,
		transformResponse: (res: ClearProductionLotCustomerGroupMutation) => res
	},
	CreateProductionLot: {
		invalidatesTags: ["ProductionLots", "ProductionJobs", "SpaceUtilization"] as AddTagTypes,
		transformResponse: (res: CreateProductionLotMutation) => res
	},
	DeactivateProductionLot: {
		invalidatesTags: ["ProductionLots", "ProductionJobs", "SpaceUtilization"] as AddTagTypes,
		transformResponse: (res: DeactivateProductionLotMutation) => res
	},
	DeleteProductionLot: {
		invalidatesTags: ["ProductionLots", "ProductionJobs", "SpaceUtilization"] as AddTagTypes,
		transformResponse: (res: DeleteProductionLotMutation) => res
	},
	GetPlannedLotStartsPreview: {
		providesTags: ["ProductionRecipe"] as AddTagTypes,
		transformResponse: (res: GetPlannedLotStartsPreviewQuery) => res
	},
	GetPostJobsDetail: {
		providesTags: ["ProductionJobs"] as AddTagTypes,
		transformResponse: (res: GetPostJobsDetailQuery) => res
	},
	GetProductionJobDimensions: {
		providesTags: ["ProductionJobs"] as AddTagTypes,
		transformResponse: (res: GetProductionJobDimensionsQuery) => res
	},
	GetProductionJobGrowWeeks: {
		providesTags: ["ProductionJobs"] as AddTagTypes,
		transformResponse: (res: GetProductionJobGrowWeeksQuery) => res
	},
	GetProductionJobLabels: {
		providesTags: ["ProductionJobs"] as AddTagTypes,
		transformResponse: (res: GetProductionJobLabelsQuery) => res
	},
	GetProductionJobPurchaseOrders: {
		providesTags: ["VendorPurchaseOrders"] as AddTagTypes,
		transformResponse: (res: GetProductionJobPurchaseOrdersQuery) => res
	},
	GetProductionJobs: {
		providesTags: ["ProductionJobs"] as AddTagTypes,
		transformResponse: (res: GetProductionJobsQuery) => res
	},
	GetProductionLot: {
		providesTags: ["ProductionLots"] as AddTagTypes,
		transformResponse: (res: GetProductionLotQuery) => res
	},
	GetProductionLotEaches: {
		providesTags: ["ProductionLotAllocations", "ProductionLots"] as AddTagTypes,
		transformResponse: (res: GetProductionLotEachesQuery) => res
	},
	GetProductionLotOverrideHistory: {
		providesTags: ["ProductionLots", "ProductionJobs", "ProductionLotOverrideHistory"] as AddTagTypes,
		transformResponse: (res: GetProductionLotOverrideHistoryQuery) => res
	},
	GetProductionLots: {
		providesTags: ["ProductionLots"] as AddTagTypes,
		transformResponse: (res: GetProductionLotsQuery) => res
	},
	GetProductionPlans: {
		providesTags: ["ProductionPlans"] as AddTagTypes,
		transformResponse: (res: GetProductionPlansQuery) => res
	},
	GetProductionScheduleJob: {
		providesTags: ["ProductionJobs"] as AddTagTypes,
		transformResponse: (res: GetProductionScheduleJobQuery) => res
	},
	GetProductionScheduleLotJobs: {
		providesTags: ["ProductionLots", "ProductionJobs"] as AddTagTypes,
		transformResponse: (res: GetProductionScheduleLotJobsQuery) => res
	},
	GetRecipeJobIds: {
		providesTags: ["ProductionJobs"] as AddTagTypes,
		transformResponse: (res: GetRecipeJobIdsQuery) => res
	},
	GetSplitProductionLot: {
		providesTags: ["ProductionLots"] as AddTagTypes,
		transformResponse: (res: GetSplitProductionLotQuery) => res
	},
	MergeProductionPlan: {
		invalidatesTags: ["ProductionPlans"] as AddTagTypes,
		transformResponse: (res: MergeProductionPlanMutation) => res
	},
	OpenPlannedMoves: {
		providesTags: ["TaskAssignments"] as AddTagTypes,
		transformResponse: (res: OpenPlannedMovesQuery) => res
	},
	PlanProductionJobMoves: {
		invalidatesTags: ["TaskAssignments", "ProductionJobs"] as AddTagTypes,
		transformResponse: (res: PlanProductionJobMovesMutation) => res
	},
	OverrideProductionJobLocation: {
		invalidatesTags: ["ProductionLots", "ProductionJobs", "SpaceUtilization"] as AddTagTypes,
		transformResponse: (res: OverrideProductionJobLocationMutation) => res
	},
	OverrideProductionJobQuantity: {
		invalidatesTags: ["ProductionLots", "ProductionJobs", "SpaceUtilization"] as AddTagTypes,
		transformResponse: (res: OverrideProductionJobQuantityMutation) => res
	},
	OverrideProductionJobWeekReady: {
		invalidatesTags: ["ProductionLots", "ProductionJobs", "SpaceUtilization"] as AddTagTypes,
		transformResponse: (res: OverrideProductionJobWeekReadyMutation) => res
	},
	OverrideProductionJobWeekStart: {
		invalidatesTags: ["ProductionLots", "ProductionJobs", "SpaceUtilization"] as AddTagTypes,
		transformResponse: (res: OverrideProductionJobWeekStartMutation) => res
	},
	OverrideProductionJobYield: {
		invalidatesTags: ["ProductionLots", "ProductionJobs", "SpaceUtilization"] as AddTagTypes,
		transformResponse: (res: OverrideProductionJobYieldMutation) => res
	},
	OverrideProductionLotCustomer: {
		invalidatesTags: ["ProductionLots", "ProductionJobs", "SpaceUtilization"] as AddTagTypes,
		transformResponse: (res: OverrideProductionLotCustomerMutation) => res
	},
	OverrideProductionLotCustomerGroup: {
		invalidatesTags: ["ProductionLots", "ProductionJobs", "SpaceUtilization"] as AddTagTypes,
		transformResponse: (res: OverrideProductionLotCustomerGroupMutation) => res
	},
	OverrideProductionLotQuantity: {
		invalidatesTags: ["ProductionLots", "ProductionJobs", "SpaceUtilization"] as AddTagTypes,
		transformResponse: (res: OverrideProductionLotQuantityMutation) => res
	},
	OverrideProducedQuantity: {
		invalidatesTags: ["ProductionLots", "ProductionJobs", "SpaceUtilization"] as AddTagTypes,
		transformResponse: (res: OverrideProducedQuantityMutation) => res
	},
	PostProductionJobs: {
		invalidatesTags: [
			"ProductionLots",
			"ProductionJobs",
			"ProductionLotAllocations",
			"InventoryItems",
			"UnallocatedAvailability",
			"SpaceUtilization"
		] as AddTagTypes,
		transformResponse: (res: PostProductionJobsMutation) => res
	},
	ProductionJobMovePreview: {
		transformResponse: (res: ProductionJobMovePreviewQuery) => res
	},
	ReopenProductionJob: {
		invalidatesTags: [
			"ProductionLots",
			"ProductionJobs",
			"ProductionLotAllocations",
			"InventoryItems",
			"UnallocatedAvailability",
			"SpaceUtilization"
		] as AddTagTypes,
		transformResponse: (res: ReopenProductionJobMutation) => res
	},
	RecordShrinkEvent: {
		invalidatesTags: ["ProductionJobs"] as AddTagTypes,
		transformResponse: (res: RecordShrinkEventMutation) => res
	},
	RemoveProductionMaterialEventFromJob: {
		invalidatesTags: ["ProductionLots", "ProductionJobs", "ProductionMaterialEvents"] as AddTagTypes,
		transformResponse: (res: RemoveProductionMaterialEventFromJobMutation) => res
	},
	RemoveProductionSpaceEventFromJob: {
		invalidatesTags: ["ProductionLots", "ProductionJobs", "ProductionSpaceEvents", "SpaceUtilization"] as AddTagTypes,
		transformResponse: (res: RemoveProductionSpaceEventFromJobMutation) => res
	},
	RemoveShrinkEvent: {
		invalidatesTags: ["ProductionJobs"] as AddTagTypes,
		transformResponse: (res: RemoveShrinkEventMutation) => res
	},
	RepairProductionJobReservationPegs: {
		invalidatesTags: ["ProductionLots", "ProductionJobs", "ProductionLotAllocations"] as AddTagTypes,
		transformResponse: (res: RepairProductionJobReservationPegsMutation) => res
	},
	SetJobPlannedHoursOverride: {
		invalidatesTags: ["ProductionLots", "ProductionJobs", "SpaceUtilization", "TaskAssignments"] as AddTagTypes,
		transformResponse: (res: SetJobPlannedHoursOverrideMutation) => res
	},
	SetProductionLotProductionItem: {
		invalidatesTags: ["ProductionLots", "ProductionJobs"] as AddTagTypes,
		transformResponse: (res: SetProductionLotProductionItemMutation) => res
	},
	SplitProductionLot: {
		invalidatesTags: ["ProductionLots", "ProductionJobs", "SpaceUtilization"] as AddTagTypes,
		transformResponse: (res: SplitProductionLotMutation) => res
	},
	SubstituteProductionLotCatalog: {
		invalidatesTags: ["ProductionLots", "ProductionJobs", "SpaceUtilization"] as AddTagTypes,
		transformResponse: (res: SubstituteProductionLotCatalogMutation) => res
	},
	SubmitDraftProductionLot: {
		invalidatesTags: ["ProductionLots", "ProductionJobs"] as AddTagTypes,
		transformResponse: (res: SubmitDraftProductionLotMutation) => res
	},
	UpdateProductionJobLocation: {
		invalidatesTags: ["ProductionLots", "ProductionJobs", "SpaceUtilization"] as AddTagTypes,
		transformResponse: (res: UpdateProductionJobLocationMutation) => res
	}
};
